export default __webpack_public_path__ + "static/media/location.faa69daa.svg";